import { isTextNode } from '../../../NewBlogSystem/utilities/htmlEditorUtils.js';

const collectElementLayout = (node, parentId = null, siblingIndex = 0, layout = new Map()) => {
  if (!node || isTextNode(node)) return layout;

  layout.set(node.id, {
    type: node.type,
    parentId,
    siblingIndex,
  });

  let elementIndex = 0;
  for (const child of node.children || []) {
    if (isTextNode(child)) continue;
    collectElementLayout(child, node.id, elementIndex, layout);
    elementIndex += 1;
  }

  return layout;
};

export const getAiSchemaChangeSummary = (beforeNode, afterNode) => {
  const before = collectElementLayout(beforeNode);
  const after = collectElementLayout(afterNode);
  let added = 0;
  let removed = 0;
  let tagChanges = 0;
  let moves = 0;

  for (const [nodeId, nextEntry] of after) {
    const previousEntry = before.get(nodeId);
    if (!previousEntry) {
      added += 1;
      continue;
    }

    if (previousEntry.type !== nextEntry.type) tagChanges += 1;
    if (
      previousEntry.parentId !== nextEntry.parentId
      || previousEntry.siblingIndex !== nextEntry.siblingIndex
    ) {
      moves += 1;
    }
  }

  for (const nodeId of before.keys()) {
    if (!after.has(nodeId)) removed += 1;
  }

  return {
    hasChanges: added > 0 || removed > 0 || tagChanges > 0 || moves > 0,
    added,
    removed,
    tagChanges,
    moves,
  };
};

export const describeAiSchemaChanges = ({
  added = 0,
  removed = 0,
  tagChanges = 0,
  moves = 0,
} = {}) => {
  const changes = [];
  if (added) changes.push(`${added} element${added === 1 ? '' : 's'} added`);
  if (removed) changes.push(`${removed} element${removed === 1 ? '' : 's'} removed`);
  if (tagChanges) changes.push(`${tagChanges} element type${tagChanges === 1 ? '' : 's'} changed`);
  if (moves) changes.push(`${moves} element${moves === 1 ? '' : 's'} moved`);
  return changes.join(', ');
};
